module.exports = __webpack_public_path__ + "static/img/Roller Silicone Rubber.9122137.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/Roller Silicone Rubber.jpg
// module id = FTVK
// module chunks = 1